module.exports = __webpack_public_path__ + "static/media/copyright1.1e427770.svg";